import { render, staticRenderFns } from "./order-flow.vue?vue&type=template&id=a3547a56"
import script from "./order-flow.vue?vue&type=script&lang=js"
export * from "./order-flow.vue?vue&type=script&lang=js"
import style0 from "./order-flow.vue?vue&type=style&index=0&id=a3547a56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports